// 무통장입금 내역 섹션 URL (2026-08-10 KST 추가)
const bankDepositsSection = "/bank-deposits";

export const bankDepositsPath = bankDepositsSection;
